<form [formGroup]="applicationConfigurationForm">
  <div class="d-flex">
    <h5 class="mt-auto small-caps">Managed Application Configuration</h5>
    @if (allowToggle()) {
      <button type="button"
              class="btn btn-outline-primary border-0 ms-auto"
              (click)="toggleEditing()">
        @if (!editing) {
          <fa-icon [icon]="['fas', 'pencil-alt']"></fa-icon>
        } @else {
          <fa-icon [icon]="['far', 'save']"></fa-icon>
        }
      </button>
    }
  </div>
  <div class="table-responsive">
    <table class="table table-sm table-list mb-4">
      <thead>
        <tr>
          <th colspan="2"
              scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <!-- Item -->
        @if (!integrated()) {
          <tr>
            <th data-placement="right"
                scope="row">
              <span class="col-form-label">Item</span>
            </th>
            <td>
              <span class="col-form-label">{{ applicationConfiguration()?.item }}</span>
            </td>
          </tr>

          <!-- Identifier -->
          <tr>
            <th title="The application’s bundle identifier."
                data-toggle="tooltip"
                data-placement="right"
                scope="row">
              <label for="identifier"
                     class="col-form-label"
                     i18n>Identifier</label>
            </th>
            <td>
              @if (!editing) {
                <span class="col-form-label">{{ applicationConfiguration()?.identifier }}</span>
              } @else {
                <input type="text"
                       class="form-control"
                       id="identifier"
                       formControlName="identifier" />
              }
            </td>
          </tr>
        }

        <!-- Configuration -->
        <tr>
          <th title="Optional. Configuration dictionary to be applied to the app. If this member is missing, any existing managed configuration for the app is removed."
              data-toggle="tooltip"
              data-placement="right"
              scope="row">
            <label for="identifier"
                   class="col-form-label"
                   i18n>Configuration</label>
          </th>
          <td class="text-end">
            @if (editing) {
              <button class="btn btn-outline-primary border-0"
                      (click)="addConfiguration()">
                <fa-icon icon="plus"></fa-icon>
              </button>
            }
          </td>
        </tr>

        <tr>
          <th class="border-0 pt-0">
            <small>Key</small>
          </th>
          <td class="border-0 pt-0">
            <small>Setting</small>
          </td>
        </tr>

        @if (editing) {
          <ng-container formArrayName="configuration">
            @for (configurationEntry of configuration.controls; track configurationEntry; let i = $index) {
              <tr [formGroupName]="i">
                <th>
                  <input type="text"
                         class="form-control"
                         formControlName="id" />
                </th>
                <td class="d-flex">
                  <input type="text"
                         class="flex-grow-1 form-control"
                         formControlName="value" />
                  <button class="btn btn-outline-primary border-0 d-block"
                          (click)="deleteConfiguration(i)">
                    <fa-icon icon="times"></fa-icon>
                  </button>
                </td>
              </tr>
            }
          </ng-container>
        } @else {
          @for (key of configurationKeysSorted; track key) {
            <tr>
              <th>
                {{ key }}
              </th>
              <td>
                {{ applicationConfiguration()?.configuration[key] }}
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
</form>